// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface ResponseModel<T = any> {
  code: number;
  data: T;
  message: string | null;
}

export enum NetworkCode {
  success = 200,
  invalid = 4011000,
  refreshTokenInvalid = 40001113,
  doing = 40002301,
}

export interface ErrorModel {
  errCode: number | string;
  errMsg: string | null;
}

export interface XyErrorModel {
  code: number;
  message: string | null;
}

export enum XyAccountError {
  userInfoError = 4001000,
  graphicCaptchaRequired = 4001003,
  graphicCaptchaInvalid = 4001004,
}

export enum PwdError {
  PwsIncorrect = 4003013,
}
